<template>
    <span class="tw:inline-flex tw:items-center">
        <button
            type="button"
            class="tw:p-0 tw:border-0 tw:bg-transparent tw:cursor-pointer tw:leading-none"
            aria-label="Ver código QR"
            @click="open"
        >
            <i class="material-icons tw:text-base tw:text-slate-400 tw:hover:text-slate-600 tw:transition-colors">
                visibility
            </i>
        </button>

        <BaseModalFront
            :show="showModal"
            :title="$t('perfil.entrada_detalle.qr_code') "
            confirm-text="Cerrar"
            confirm-variant="ghost"
            :show-cancel="false"
            @confirm="showModal = false"
            @close="showModal = false"
        >
            <div class="tw:flex tw:items-center tw:justify-center tw:py-4">
                <div v-if="generating" class="tw:flex tw:items-center tw:justify-center tw:w-64 tw:h-64">
                    <i class="material-icons tw:text-4xl tw:text-slate-300 tw:animate-spin">refresh</i>
                </div>
                <div v-else-if="qrSrc">
                    <img
                        :src="qrSrc"
                        alt="Código QR"
                        class="tw:w-64 tw:h-64 tw:rounded-lg"
                    />
                    <p class="tw:text-md tw:text-slate-500 tw:font-mono tw:text-center">
                        {{ value }}
                    </p>
                </div>
            </div>
        </BaseModalFront>
    </span>
</template>

<script setup>
    import { ref, watch } from 'vue';
    import QRCode from 'qrcode';
    import BaseModalFront from '@/modules/front/ui/BaseModalFront.vue';

    const props = defineProps({
        value: { type: String, required: true },
    });

    const showModal = ref(false);
    const qrSrc = ref('');
    const generating = ref(false);

    const generate = async() => {
        if (!props.value) return;
        generating.value = true;
        try {
            qrSrc.value = await QRCode.toDataURL(props.value, { width: 256, margin: 2 });
        } finally {
            generating.value = false;
        }
    };

    watch(() => props.value, () => {
        qrSrc.value = '';
    });

    const open = async() => {
        showModal.value = true;
        await generate();
    };
</script>
